import React from "react"

const AdArticleUnderRect = ({slot, id}) => {
  return (
    <div style={{marginTop: 20, marginBottom: 20}} dangerouslySetInnerHTML={{ __html: `</script><!-- ${slot} --><div id="${id}" style="width: 336px; height: 280px;"><script>googletag.cmd.push(function() { googletag.display('${id}'); });</script></div>` }} />
  )
}

export default AdArticleUnderRect
